export default __webpack_public_path__ + "assets/png/53e3b6a09be4435e4308cfa0a395f544.png";